import { HeaderPage } from "../../../components/header-page/HeaderPage";

export const UserHeader = () => {
  return <HeaderPage title="Usuarios" />;
};
